import { HintStateInterface } from './types';

export const initialHintState: HintStateInterface = {
  isShow: false,
  text: '',
};
